import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useMenu } from 'src/contexts/menu-context'
import { LEVELS } from '../constants'
import { AlphabeticalMenu } from './MenuComponents/AlphabeticalMenu/AlphabeticalMenu'
import { ListMenu } from './MenuComponents/ListMenu/ListMenu'

export const ThirdLevel = () => {
  const { updatedMenu } = useGlobalNavigation()
  const { state } = useMenu()

  return (
    <div
      className={`w-[360px] h-screen navigation-panel-step ${
        typeof state.firstLevelItem?.index === 'number' &&
        typeof state.secondLevelItem?.index === 'number' &&
        updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
          state.secondLevelItem.index
        ]?.nextLevel?.items !== null
          ? 'active'
          : ''
      }`}
    >
      {typeof state.firstLevelItem?.index === 'number' &&
        typeof state.secondLevelItem?.index === 'number' &&
        updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
          state.secondLevelItem.index
        ]?.nextLevel?.items !== null &&
        (updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
          state.secondLevelItem.index
        ]?.nextLevel?.alphabeticalMenu ? (
          <AlphabeticalMenu
            menu={
              updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
                state.secondLevelItem.index
              ]?.nextLevel!
            }
          />
        ) : (
          <ListMenu
            menu={
              updatedMenu[state.firstLevelItem.index]?.nextLevel?.items[
                state.secondLevelItem.index
              ]?.nextLevel!
            }
            type={LEVELS.third_level.toString()}
            level={LEVELS.third_level}
          />
        ))}
    </div>
  )
}
